module.exports = __webpack_public_path__ + "img/IMG-20210623-WA0002.60a4ea28.jpg";